<template>
  <div id="app">
    <div class="menu-pr-box" v-if="screenWidth > 750">
      <div class="log-pr-box">
        <!-- <img src="@/assets/logo.png" alt=""> -->
        <span>Más Crédito</span>
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'choice-pr' : ''">Inicio</div>
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice-pr' : ''">Obtenga fondos </div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice-pr' : ''">Pago flexibles</div>
        <div @click="choiceMenu(3)" :class="(menuIndex === 3) ? 'choice-pr' : ''">Contáctenos</div>
        <!-- <div @click="choiceMenu(4)" :class="(menuIndex===4)?'choice-pr':''">Tiga keuntungan</div> -->
      </div>
    </div>
    <div id='step_1' ref="step_1" class="ref-home"></div>
    <div class="banner-pr-box" id='home' ref="home">
      <img src="../assets/banner.png" class="banner">
      <div class="app-pr-name">
        <div class="banner-text">
          <!-- <p>Inclusive and accessible <span>digital financial services</span> for everyone</p> -->
          <div>Más Crédito es una aplicación de préstamos en línea líder en Colombia que se enfoca en brindar soluciones de préstamos en línea simples, rápidas y flexibles para satisfacer las necesidades financieras de los usuarios. Esta plataforma tiene varias ventajas que hacen que pedir dinero prestado sea más fácil y conveniente.</div>
        </div>
        <div class="btn" @click="download()">
          Descargar
        </div>
      </div>
    </div>

    <div id='step_2' ref="step_2"></div>
    <div class="img-box">
      <img src="../assets/img-1.png" alt="">
      <div class="text-1-box">
        <div class="title">Obtenga fondos rápidamente:</div>
        <div>La promesa principal de Más Crédito es permitir a los usuarios obtener los fondos que necesitan en el menor tiempo posible. Los prestatarios pueden obtener préstamos a través de un sencillo proceso de solicitud en línea sin largos tiempos de espera ni procedimientos complicados. Esto es muy útil para los usuarios que necesitan fondos durante emergencias.</div>
      </div>
    </div>

    <div id='step_3' ref="step_3"></div>
    <div class="img-box">
      <img src="../assets/img-2.png" alt="">
      <div class="text-2-box">
        <div class="text-box">
          <div>Fuerte equipo de control de riesgos:</div>
          <p>Más Crédito cuenta con un equipo profesional de control de riesgos que utiliza tecnología avanzada y análisis de datos para garantizar que los prestatarios reciban los montos de préstamo adecuados. Esto garantiza la asequibilidad del préstamo y reduce riesgos financieros innecesarios.</p>
        </div>
      </div>
    </div>

    <!-- <div id='step_4' ref="step_4"></div> -->
    <div class="img-box">
      <img src="../assets/img-3.png" alt="">
      <div class="text-1-box">
        <div class="title">Opciones de pago flexibles:</div>
        <div>Más Crédito entiende que la capacidad de pago de cada prestatario puede ser diferente y, por lo tanto, ofrece una variedad de opciones de pago que se adaptan a diferentes situaciones financieras. Esto incluye opciones como el pago mensual y el pago a plazos, lo que permite a los prestatarios elegir el método de pago que mejor les convenga.</div>
      </div>
    </div>

    <!-- <div id='step_5' ref="step_5"></div> -->
    <div class="img-box">
      <img src="../assets/img-4.png" alt="">
      <div class="text-3-box">
        <div class="text-3-title">Cómo utilizar Más Crédito</div>
        <div class="list-box">
          <div class="item">1. Descargar Más Crédito </div>
          <div class="item">2. Utilice su número de teléfono móvil para registrarse como usuario</div>
          <div class="item">3. Complete la información requerida para la solicitud de préstamo</div>
          <div class="item">4. Espere la aprobación y el préstamo ingrese a la cuenta que completó</div>
        </div>
      </div>
    </div>

    <div id='step_4' ref="step_4"></div>
    <div class="footer-box">
      <div class="title-box">
        <p>Contáctenos</p>
        <p>Más Crédito</p>
      </div>
      <div class="img-box">
        <!-- <img src="../assets/icon-min-4.png" alt=""> -->
        <p style="font-size: 18px;"> Mas Soluciones S.A.S.</p>
      </div>
      <div class="img-box">
        <img src="../assets/icon-min-2.png" alt="">
        <p>atn.clientes.massoluciones@gmail.com</p>
      </div>
      <div class="img-box">
        <img src="../assets/icon-min-3.png" alt="">
        <p> CR 80 18 7, Medellín, Colombia</p>
      </div>
    </div>
    <div class="copyright-pr">Copyright© Más Crédito. All rights reserved</div>
  </div>
</template>

<script>
import privacy from "@/components/privacy";
export default {
  name: 'App',
  components: {
    privacy
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    let item = this.$route.query.item
    console.log(item);
    if (item == 'partners') {
      this.$nextTick(() => {
        setTimeout(() => {
          this.choiceMenu(4)
        }, 1000);
      })
    }
  },
  methods: {
    download(){
      window.open("https://g1h.me/jf97")
    },
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("step_1").scrollIntoView(); break;
        case 1: document.getElementById("step_2").scrollIntoView(); break;
        case 2: document.getElementById("step_3").scrollIntoView(); break;
        case 3: document.getElementById("step_4").scrollIntoView(); break;
        case 4: document.getElementById("step_5").scrollIntoView(); break;
        case 5: document.getElementById("step_6").scrollIntoView(); break;
        case 6: document.getElementById("step_7").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    },
    gotoPrivacy() {
      this.$router.push({
        path: "/Privacy",
      });
    }
  }
}
</script>


<style lang="less" >
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
